import { TextSizeType } from "../Text";

function isSpecificSize(size) {
    switch (size) {
        case "xxs":
        case "xs":
        case "sm":
        case "md":
        case "lg":
        case "xl":
        case "xxl":
            return true;
        default:
            return false;
    }
}

function transFontSize({size}: {size: TextSizeType | number | string}) {
    let fontSizeValue: any = 16;
    if(isSpecificSize(size)) {
        if(size === "xxs") { fontSizeValue = 10 }
        else if(size === "xs") { fontSizeValue = 12 }
        else if(size === "sm") { fontSizeValue = 14 }
        else if(size === "md") { fontSizeValue = 16 }
        else if(size === "lg") { fontSizeValue = 18 }
        else if(size === "xl") { fontSizeValue = 24 }
        else if(size === "xxl") { fontSizeValue = 32 }
        return fontSizeValue
    }
    if(size == parseInt(size as string)) {
        fontSizeValue = parseInt(size as string);
    } else {
        fontSizeValue = size;
    }

    return fontSizeValue;
}

export default transFontSize;